import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';

import {
  DataAccessService,
  GetStatesDocument,
  GetCountriesDocument,
  State,
  Country,
  GetStatesQuery,
  GetCountriesQuery
} from '@tripointe/tripointe-cms/data-access';
import { matchId } from '@tripointe/tripointe-cms/utils';

@Injectable({ providedIn: 'root' })
export class CountriesService {
  loading$ = new BehaviorSubject(false);
  states$ = new BehaviorSubject([]);
  countries$ = new BehaviorSubject([]);

  constructor(private dataAccess: DataAccessService) {}

  setLoading(isLoading: boolean): void {
    this.loading$.next(isLoading);
  }

  setStates(states: Partial<State | { country: Partial<Country> }>[]): void {
    this.states$.next(states);
  }

  setCountries(countries: Partial<Country>[]): void {
    this.countries$.next(countries);
  }

  loadStates(): void {
    this.setLoading(true);

    this.dataAccess
      .get<GetStatesQuery>(GetStatesDocument)
      .pipe(finalize(() => this.setLoading(false)))
      .subscribe(({ data: { getStates: response } }) => {
        this.setStates(response.states);
      });
  }

  loadCountries(): void {
    this.setLoading(true);

    this.dataAccess
      .get<GetCountriesQuery>(GetCountriesDocument)
      .pipe(finalize(() => this.setLoading(false)))
      .subscribe(({ data: { getCountries: response } }) => {
        this.setCountries(response.countries);
      });
  }

  countryHasState(countryId: number, stateId: number): boolean {
    if (!countryId || !stateId) {
      return false;
    }

    const allStates = this.states$.value;

    const state = allStates.find(matchId(stateId));

    return state.country.id === countryId;
  }
}
